import {ReactComponent as ReloadIcon} from './reload.svg'

function Reload() {
  return <ReloadIcon />
}

export default Reload
